module.exports = __webpack_public_path__ + "img/avatar-zelf-man.68768790.jpeg";